<template>
<div class="search_wrapper">
  <div class="search_placeholder">
    <div class="search_top">
      <div class="sign">
        <span class="sign_btn" @click="signIn">{{hasSign*1==1?"已签到":"签到"}}</span>
      </div>
      <form @submit.prevent="storeKeys">
        <div class="search_box">
          <div class="search_text_wrapper">
            <input type="text" name="" value="" class="search_text" placeholder="请输入商品或者关键词" id="search_text"><input type="reset" name="" value="" class="search_reset icon "><span class="icon-search icon_search"></span><span class="icon-close icon_close"></span>
          </div>
          <input type="submit" class="search_btn" value="搜索">
        </div>
      </form>
    </div>
  </div>
  <histroyKeyWords :deletestoreKeys="deletestoreKeys"></histroyKeyWords>
  <course></course>



</div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
import Vue from "vue"
import Course from '@/components/search/course'
import HistroyKeyWords from '@/components/search/histroyKeyWords'
import Login from '@/components/login/login'
import {Toast} from "mint-ui"
export default {
  name: "search",
  data() {
    return {
      //localHistoryKeys: [],
      searchValue: '',
      //hasSign:localStorage.hasSign
    }
  },
  created: function() {
  //this.hasSign =
  //console.log(this.hasSign)



  },
  mounted: function() {},
  methods: {
    clipGoodsid: function(goodsID, cb) { //从喵口令的goodis  获取title
      let kUrl = "api/getTitleByGoodid.php?id=" + goodsID
      //console.log(this.url )
      this.$ajax.autoService
        .login(kUrl)
        .then((res) => {
          var title = res.data.results.n_tbk_item["0"].title
          typeof cb == "function" && cb(title) //如果从聚口令令中得到标题，就返回标题
          //console.log(this.item)
        }, (res) => {
          console.log("error")
        })
    },
    clipPasswordData: function(password, cb) {
      let url = ''
      let goodsID = ''
      let content = ''
      let tUrl = "api/getPasswordContent.php?password=" + password
      //console.log(this.url )
      this.$ajax.autoService
        .login(tUrl)
        .then((res) => {
          //console.log(res)
          url = res.data.url + '&'
          content = res.data.content

          if (url.match(/item[Ii][Dd]=.*?&/)) {
            goodsID = url.match(/item[Ii][Dd]=.*?&/)[0].replace(/item[Ii][Dd]=/, '').replace("&", '')
          } else if (url.match(/[&\?][Ii][Dd]=.*?&/)) {
            goodsID = url.match(/[&\?][Ii][Dd]=.*?&/)[0].replace(/[&\?][Ii][Dd]=/, '').replace("&", '')
          }
          //console.log('goodsid:' + goodsID)
          if (goodsID != '') {
            let t1Url = "api/getTitleByGoodid.php?id=" + goodsID
            this.$ajax.autoService
              .login(tUrl)
              .then((res) => {
                //console.log(res)
                let title = res.data.content
                typeof cb == "function" && cb(title) //如果从淘口令中得到标题，就返回标题
              })
          } else {
            content = content.replace(/\r|\n/g, '')
            content = content.replace(/\.\.\..*$/, '')
            content = content.replace(/【.*$/, '')
            typeof cb == "function" && cb(content) //如果从淘口令中得到标题，就返回标题
          }
        }, (res) => {
          console.log("error")
        })
    },
    storeKeys: function() {
      //console.log(document.querySelector('#search_text').value)
      this.searchValue = document.querySelector('#search_text').value;
      var that = this
      //正则匹配关键词
      if (this.searchValue.match(/喵口令/)) {
        var tmallTitle = this.searchValue.match(/【.*】/)[0].replace('【', '').replace('】', '')
        //console.log(tmallTitle)
        that.searchValue = tmallTitle
        that.routeJump()
      } else if (this.searchValue.match(/item_id=\d*&/)) { //如果是聚口令分享过来的，解析出GOODSID
        //console.log(this.searchValue.match(/item_id=\d*&/)[0])
        goodsid = this.searchValue.match(/item_id=\d*&/)[0].replace('item_id=', '').replace('&', '')
        this.clipGoodsid(goodsid, function(title) {
          that.searchValue = title
          that.routeJump()
          //that.searchDo(keyword, formId)
        })
      } else if (this.searchValue.match(/(\?|&)id=\d*&/)) {
        //console.log(this.searchValue.match(/(\?|&)id=\d*&/)[0])
        goodsid = this.searchValue.match(/(\?|&)id=\d*&/)[0].replace(/(\?|&)id=/, '').replace('&', '')
        //console.log(goodsid)
        this.clipGoodsid(goodsid, function(title) {
          that.searchValue = title
          that.routeJump()
        })
      } else if (this.searchValue.match(/￥.*?￥/)) { //对keyword进行处理，如果包含淘口令的，解析出标题
        var tempTKL = this.searchValue.match(/￥.*?￥/)[0]
        var tempKeyword
        this.clipPasswordData(tempTKL, function(title) {
          //console.log("最后搜索关键词:" + title)
          that.searchValue = title
          that.routeJump()
        })
      } else if (this.searchValue.match(/€.*?€/)) { //对keyword进行处理，如果包含淘口令的，解析出标题
        var tempTKL = this.searchValue.match(/€.*?€/)[0]
        var tempKeyword
        this.clipPasswordData(tempTKL, function(title) {

          that.searchValue = title
          //console.log("最后搜索关键词:" + that.searchValue)
          that.routeJump()
        })
      } else {
        this.routeJump()
      } //路由跳转以及历史搜索词

      // this.historyKeys.push(document.querySelector('#search_text').value)
      //  localStorage.setItem("nameSpace", "[1,2]");
      //console.log(JSON.parse(localStorage.nameSpace))
    },
    routeJump: function() {
      this.$router.push({
        name: 'searchResulte',
        query: {
          keyWord: this.searchValue,
          cat:""

        }
      })
      //console.log(this.searchValue)
      this.$store.dispatch("changeLocalHistoryKeys",this.searchValue)//储存搜索关键词
    },
    deletestoreKeys: function() {
      this.$store.dispatch("deleteLocalHistoryKeys",this.searchValue)//删除搜索关键词
    },
    signIn: function(){
      if(sessionStorage.islogged && JSON.parse(sessionStorage.islogged)){
        this.$store.dispatch('signIn')
      }
      else{
        Toast({
          message:"请先关注搜券王微信公众号，通过微信公众号进入则可以签到赚券币"
        })
      }
    }

  },
  computed: {
    hasSign:function(){
      return this.$store.state.hasSign
    }
  },
  components: {
    'course': Course,
    'histroyKeyWords': HistroyKeyWords,
    'login':Login
  },
  mounted() {}
}
</script>
<style lang="stylus">
  .search_wrapper
    background:#ff0026
    .search_placeholder
      width:10rem
      height:268px
      .search_top
        width:10rem
        height:268px
        background:url(../../images/mine_bg.png)no-repeat left top;
        background-size:100% 268px;
        position:fixed
        .sign
          width:10rem
          padding:30px 0 0 30px
          box-sizing:border-box
          .sign_btn
            padding:0 20px
            height:40px
            border:1px solid #fff
            /*px*/
            border-radius:20px
            display:inline-block
            text-align:center
            font-size:24px
            line-height:40px
            color:#fff
        .search_box
          margin-top:100px
          display:flex
          padding:0 30px
          width:100%
          box-sizing:border-box
          .search_btn
            flex:0 0 100px
            height:60px
            line-height: 60px;
            font-size: 30px;
            color: #fff;
            border: 1px solid #f2f2f2;
            /*px*/
            background: transparent;
            box-sizing: border-box;
            border-radius:10px
            text-align:center
          .search_text_wrapper
            flex:1
            height:60px
            position:relative
            padding-right:20px
            box-sizing:border-box
            .search_text
              padding: 5px 50px;
              width: 100%;
              height: 60px;
              line-height: 60px;
              font-size: 28px;
              border-radius: 10px
              color: #aaa
              background: #fff
              overflow: hidden
              box-sizing:border-box
              border:0
              color:#333
            .search_reset
              position:absolute
              right:30px
              top:0px
              width:60px
              height:60px
              z-index:2
              background:none
              border:0px
            .icon_search
              position:absolute
              width:60px
              height:60px
              color:#666
              z-index:1
              font-size:24px
              line-height:60px
              left:20px
              top:0px
            .icon-close
              font-size:18px
              color:#666
              right:40px
              top:15px
              width:30px
              height:30px
              line-height:30px
              border:1px solid #999
              /*px*/
              text-align:center
              border-radius:15px
              display:inline-block
              position:relative
              position:absolute
  .clipboard
    width:690px
    height:300px
    position:fixed
    left:0px
    bottom:100px
    background:rgba(0,0,0,0.5)




</style>



// WEBPACK FOOTER //
// src/components/search/search.vue